import type { AxiosPromise } from "axios";
import { apiClient } from "@/api/modules/base";
import type { LanguageItemsListItem } from "@/api/modules/autoQ/languageItems/types";
import { Route } from "@/api/modules/autoQ/languageItems/route";

export const list = (): AxiosPromise<LanguageItemsListItem[]> =>
    apiClient.get(Route.LanguageItems);
